// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"1427":"066ef871","1637":"5bda4a79","3207":"a09737c4","7142":"f0a39469","8465":"31d320a2"}[chunkId] + ".js";
};